import { createSlice } from '@reduxjs/toolkit';

export const userOnboardingSlice = createSlice({
  name: 'userOnboarding',
  initialState: {
    user_onboard_password: '',
    user_onboard_newpassword: '',
    user_onboard_pin: '',
    user_onboard_did_numbers: [],
    user_onboard_users: {},
    user_onboard_user_details: [],
    user_onboard_company_details: [],
    user_onboard_company_address: [],
    user_onboard_extensions: [],
    user_onboard_direct_number: '',
    user_onboard_did_display: '',
    user_onboard_total_user_purchased: 0,
    user_onboard_total_licensed_user: 0,
    user_onboard_total_unlicensed_user: 0,
    user_onboard_call_forwarding_list: [],
    user_onboard_url_data: {},
    user_onboard_company_greetings: {},
    user_onboard_mydetails_regional_settings: {},
    user_onboard_mydetails_emergency: {},
    user_onboard_voicemail_greetings: {},
    user_onboard_url: {},
    user_onboard_check_login: {},
    user_onboard_user_info: {},
    admin_user_details_info: {}
  },
  reducers: {
    setOnboardingURL: (state, action) => {
      state.user_onboard_url = action.payload;
    },
    setOnboardingURLData: (state, action) => {
      state.user_onboard_url_data = action.payload;
    },
    setOnboardingVoiceMailGreetings: (state, action) => {
      state.user_onboard_voicemail_greetings = action.payload;
    },
    setOnboardingRegionalSettings: (state, action) => {
      state.user_onboard_mydetails_regional_settings = action.payload;
    },
    setOnboardingUserPin: (state, action) => {
      state.user_onboard_pin = action.payload;
    },
    setOnboardingUserPassword: (state, action) => {
      state.user_onboard_password = action.payload;
    },
    setOnboardingUserDetails: (state, action) => {
      state.user_onboard_user_details = action.payload;
    },
    setOnboardingUserInfo: (state, action) => {
      state.user_onboard_user_info = action.payload;
    },
    setOnboardingAdminDetails: (state, action) => {
      state.admin_user_details_info = action.payload;
    },
  }
});

export const {
  setOnboardingUserPassword,
  setOnboardingUserPin,
  setOnboardingRegionalSettings,
  setOnboardingVoiceMailGreetings,
  setOnboardingURL,
  setOnboardingURLData,
  setOnboardingUserDetails,
  setOnboardingAdminDetails,
  setOnboardingUserInfo
} = userOnboardingSlice.actions

export default userOnboardingSlice.reducer;